export function parseDate(date: string | null) {
    if (date) {
        const [year, month, day] = date.split('-')
        return day ? day + '/' + month + '/' + year : null
    }
    return null
}
export function parseDateTime(datetime: string | null) {
    if (datetime) {
        const [date, time] = datetime.split(' ')
        const [year, month, day] = date.split('-')
        return day ? day + '/' + month + '/' + year + ' ' + time : null
    }
    return null
}

export function getWeekdayName(date: string) {
    const weekdayNames = [
        'Domingo',
        'Segunda-Feira',
        'Terça-Feira',
        'Quarta-Feira',
        'Quinta-Feira',
        'Sexta-Feira',
        'Sábado',
    ]
    const [year, month, day] = date.split('-')

    return weekdayNames[new Date(Number(year), Number(month) - 1, Number(day)).getDay()]
}

export function parseDateTimeToDate(datetime: string | null): Date | null {
    if (!datetime) {
        return null
    }
    const [date, time] = datetime.split(' ')
    const [day, month, year] = date.split('/')
    if (!day || !month || !year) {
        return null
    }
    const [hours, minutes, seconds] = (time ?? '00:00:00').split(':')
    return new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hours) || 0,
        Number(minutes) || 0,
        Number(seconds) || 0
    )
}

export function addBusinessDays(date: Date, days: number): Date {
    const result = new Date(date)
    let addedDays = 0
    while (addedDays < days) {
        result.setDate(result.getDate() + 1)
        const weekday = result.getDay()
        if (weekday !== 0 && weekday !== 6) {
            addedDays++
        }
    }
    return result
}

export function formatDateBR(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
}
